import axios from 'axios';
import { cartInfoUpdate } from './cart';
import { API_URL, DID, WLID, ADID, DEFAULT_LATITUDE, DEFAULT_LONGITUDE, ONLINE_URL } from '../config/constants';

import { cartSetReorderLoading, cartLoadReorderItems, cartReset } from './cart';
import { cartItemUpdateSauce } from './cartItem';

export const loadCurrentLocation = (location) => {
    return {
        type: 'LOAD_LOCATION_INFO',
        location
    };
};

export const currentLocationError = (error) => {
    return {
        type: 'LOCATION_ERROR',
        error
    };
};

export const currentLocationLoading = () => {
    return {
        type: 'CURRENT_LOCATION_LOADING'
    };
};

export const getCurrentLocation = (location_id = 0, redirectToCart = false, navigation = {}, reorder_information = {}, ignore_cart_reset = false) => {
    return (dispatch) => {

        let params = {};

        if (location_id == 0) {

            // no location passed to the action, see if there's a white label id
            if (WLID != 0) {
                params = {
                    lid: WLID
                };
            }
            else {
                dispatch(currentLocationError("Invalid location supplied."));
            }
        }
        else {
            params = {
                lid: location_id
            };

            // attempt to retrieve the restaurant
            axios.get(API_URL+'/api/order/location', { params })
                .then(function(res) {

                    if (res.data.status == "success") {
                    
                        dispatch(loadCurrentLocation(res.data.data));
                        
                        let pickupType = '';
                        if (res.data.data.location.pickup_options == "DELIVERY ONLY") {
                            pickupType = 'delivery';
                        }
                        else if (res.data.data.location.pickup_options == "PICKUP ONLY") {
                            pickupType = 'pickup';
                        }
                        dispatch(cartInfoUpdate({prop: 'order_type', value: pickupType}));

                        if (redirectToCart) {

                            // set the items
                            dispatch(cartLoadReorderItems(reorder_information, res.data.data));

                            dispatch(cartSetReorderLoading(false));
                            navigation.push('/demo/'+location_id+'/cart');
                        }
                        else if (!ignore_cart_reset) {
                            dispatch(cartReset());
                        }
                    }
                    else {
                        console.log(res.data.error);
                        dispatch(currentLocationError("We're sorry, but we couldn't load the location. Please visit our website at "+ONLINE_URL+" to make an order."));
                    }
                })
                .catch(function(err) {
                    console.log("error!");
                    console.log(err.response);
                    console.log(err);
                    dispatch(currentLocationError("We're sorry, but we couldn't load the location. Please visit our website at "+ONLINE_URL+" to make an order."));
                });
        }
    };
};